import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { Scene } from '../interfaces/scene.interface';
import { IHistoryState } from '../interfaces/history-state.interface';
import equal from "deep-equal";

const historyState: IHistoryState = {
  current: null,
  direction: true,
  stack: [null],
}

export const historySlice = createSlice({
  name: "history",
  initialState: historyState,
  reducers: {
    pushScene: (state, action: PayloadAction<Scene>) => {
      const currentIndex = state.stack.findIndex(scene => {
        return equal(
          { ...scene, status: undefined, subState: { ...scene.subState, status: undefined }}, 
          { ...state.current, status: undefined, subState: { ...state.current.subState, status: undefined }}
        );
      });

      state.stack.length = currentIndex + 1;
      state.stack.push(action.payload);
      state.current = action.payload;
    },

    back: (state) => {
      const currentIndex = state.stack.findIndex(scene => {
        return equal(
          { ...scene, status: undefined, subState: { ...scene.subState, status: undefined }}, 
          { ...state.current, status: undefined, subState: { ...state.current.subState, status: undefined }}
        );
      });
      if (currentIndex != -1) state.current = state.stack[currentIndex - 1];
    },

    forward: (state) => {
      const currentIndex = state.stack.findIndex(scene => {
        return equal(
          { ...scene, status: undefined, subState: { ...scene.subState, status: undefined }}, 
          { ...state.current, status: undefined, subState: { ...state.current.subState, status: undefined }}
        );
      });
      if (state.stack[currentIndex + 1]) state.current = state.stack[currentIndex + 1];
    },
  
    popScene: (state) => {
      const record = state.stack.pop() || state.current;
      if (record.subState) record.subState.status = true;
      record.status = true;
      state.current = record;
    },

    changeScene: (state, action: PayloadAction<{ current: Scene, update: Scene }>) => {
      const index = state.stack.findIndex(scene => {
        return equal(
          { ...scene, status: undefined, subState: { ...scene.subState, status: undefined }}, 
          { ...action.payload.current, status: undefined, subState: { ...action.payload.current?.subState, status: undefined }}
        );
      });

      state.stack[index]  = action.payload.update;
    },
  
    changeCurrentState: (state, action: PayloadAction<Scene>) => {
      const index = state.stack.findIndex(scene => {
        return equal(
          { ...scene, status: undefined, subState: { ...scene.subState, status: undefined }}, 
          { ...action.payload, status: undefined, subState: { ...action.payload.subState, status: undefined }}
        );
      });
      state.stack[index] = action.payload;
      state.current = action.payload;
    },
  
    setDirection: (state, action: PayloadAction<boolean>) => {
      state.direction = action.payload;
    },
  
    setScene: (state, action: PayloadAction<Scene>) => {
      const currentIndex = state.stack.findIndex(scene => equal(scene, state.current));
      state.stack[currentIndex] = action.payload;
      state.current = action.payload;
    },

    rollupHistory: (state) => {
      const currentIndex = state.stack.findIndex(scene => equal(scene, state.current));
      state.stack.length = currentIndex + 1;
    }
  }
});

export const {setScene, setDirection, changeCurrentState, popScene, pushScene, back, forward, changeScene, rollupHistory } = historySlice.actions;
export default historySlice.reducer;